import { useSnackbar as useNotistackSnackbar } from 'notistack';

/* Planner/Tracker toasts render top-right instead of notistack's bottom-left default. */
export const useSnackbar = () => {
  const { enqueueSnackbar, ...rest } = useNotistackSnackbar();
  return {
    ...rest,
    enqueueSnackbar: (message, options) => enqueueSnackbar(message, {
      anchorOrigin: { vertical: 'top', horizontal: 'right' },
      ...options,
    }),
  };
};
